import {z} from 'zod';

export const basicInformationFormSchema = z.object({
  isActive: z.boolean(),
  name: z.string(),
  branchIds: z.array(z.string()).nullish(),
  authorizationProfileIds: z.array(z.string()).nullish(),
  number: z.string().nullish(),
  servicePackageCategoryId: z.string(),
  vehicleType: z.array(z.string()).nullish(),
  vehicleMakes: z.array(z.string()).nullish(),
  vehicleModelFamilies: z.array(z.string()).nullish(),
  vehicleModels: z.array(z.string()).nullish(),
  vehicleAgeType: z.enum(['VEHICLE_AGE_UNDECIDED', 'VEHICLE_AGE_DECIDED']),
  vehicleAgeFrom: z.number().nullish(),
  vehicleAgeTo: z.number().nullish(),
  isLockServicePackage: z.boolean(),
  isDoNotApplyDiscount: z.boolean(),
});

export type BasicInformationFormType = z.infer<typeof basicInformationFormSchema>;
